import api from '../../../services/api';

/**
 * @param {string} profileId
 * @param {number} employeeId
 * @returns {string}
 */
const API_URL = (profileId, employeeId) => `/api/v1/manager/BidProfile/${profileId}/behalf/${employeeId}`;

/**
 * @param {string} bidProfileId
 * @param {number} employeeId
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const EmployeeView = (bidProfileId, employeeId) => api.get(API_URL(bidProfileId, employeeId));

/**
 * @param {string} bidProfileId
 * @param {number} employeeId
 * @param {EmployeeBidSelection.IEmployeePreferentialBidSelection} selections
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const SubmitSelection = (bidProfileId, employeeId, selections) => api.post(
    `${API_URL(bidProfileId, employeeId)}/submit`,
    selections,
);

/**
 * @param {string} bidProfileId
 * @param {number} employeeId
 * @returns {Promise<ApiEmployee.GetBidProfileResponse>}
 */
export const Decline = (bidProfileId, employeeId) => api.post(
    `${API_URL(bidProfileId, employeeId)}/decline`,
);
